document.addEventListener("DOMContentLoaded", function () {
	const accordionContainers = document.querySelectorAll(".pk-accordion");	

	function toggleItem(item, container) {
		const toggle = item.querySelector(".pk-accordion-item-head");
		const content = item.querySelector(".pk-accordion-item-content");
		if (!toggle || !content) return;

		const singleActive = container.hasAttribute("data-single-active");
		const isCurrentlyOpen = item.classList.contains("active");

		if (singleActive && !isCurrentlyOpen) {
			container.querySelectorAll(".pk-accordion-item.active").forEach((openItem) => {
				const openToggle = openItem.querySelector(".pk-accordion-item-head");
				const openContent = openItem.querySelector(".pk-accordion-item-content");
				openItem.classList.remove("active");
				if (openToggle) openToggle.setAttribute("aria-expanded", "false");
				if (openContent) openContent.setAttribute("aria-hidden", "true");
			});
		}

		const isOpen = item.classList.toggle("active");
		toggle.setAttribute("aria-expanded", String(isOpen));
		content.setAttribute("aria-hidden", String(!isOpen));
	}

	accordionContainers.forEach((container) => {
		const items = container.querySelectorAll(".pk-accordion-item");

		items.forEach((item) => {
			const toggle = item.querySelector(".pk-accordion-item-head");
			const content = item.querySelector(".pk-accordion-item-content");
			if (!toggle || !content) return;

			const isOpen = item.classList.contains("active");
			toggle.setAttribute("aria-expanded", String(isOpen));
			content.setAttribute("aria-hidden", String(!isOpen));

			toggle.addEventListener("click", () => toggleItem(item, container));
		});
	});
});